export const boxShadow =
  '0 4px 12px rgba(0, 0, 0, 0.25), 0 0 4px rgba(0, 0, 0, 0.12)';
